import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "GlobalCatalogueBikeSearch" })
export default class GlobalCatalogueBikeSearch extends Vue {
    public localizer: any = Localizer;

    public formData: any = {
        type: { brandName: null, modelName: null, typeName: null, ccm: null, year: null, productTypes: ["All"] },
        code: { code: null }
    };

    public brands: any[] = [];
    public models: any[] = [];
    public ccms: any[] = [];
    public years: any[] = [];
    public codes: any[] = [];

    public suggestionIndex: number = -1;
    public suggestionMode: string = null;
    public suggestions: any[] = [];

    public brandTitle: string = "";
    public modelTitle: string = "";
    public ccmTitle: string = "";
    public yearTitle: string = "";
    public isReportCode: boolean = false;
    public isReported: boolean = false;
    public isProductTypeMenu: boolean = false;
    public selectedProductTypes: string = null;

    public aftermarketList: any[] = [];
    public isSelectingAllAftermarket: boolean = true;

    public isLoading: boolean = false;
    public validationErrors: any[] = [];

    @Prop() readonly culture: string;
    @Prop() readonly filter: any;
    @Prop() readonly searchBikeProductTypes: any;
    @Prop() readonly isHome: boolean;
    @Prop() readonly isUserAuthenticated: boolean;
    @Prop() readonly searchMode: string;
    @Prop() readonly vehicleFilter: any;

    @Watch("searchMode") onSearchModeChanged(newValue: any) {
        this.validationErrors = [];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        if (this.filter.brandName) {
            await this.getBrands();

            const brand = this.brands.find(x => x.title === this.filter.brandName);
            if (brand) {
                this.formData.type.brandName = brand.value;
                this.brandTitle = brand.title;
            }
        }

        if (this.filter.brandName && (this.filter.modelName || this.filter.typeName)) {
            await this.getModels();

            const model = this.models.find(x => x.modelName === this.filter.modelName && x.typeName === this.filter.typeName);
            if (model) {
                this.formData.type.modelName = model.modelName;
                this.formData.type.typeName = model.typeName;
                this.modelTitle = model.title;
            }
        }

        if (this.filter.brandName && (this.filter.modelName || this.filter.typeName) && this.filter.cCm) {
            await this.getCCms();

            const ccm = this.ccms.find(x => x.title === this.filter.cCm);
            if (ccm) {
                this.formData.type.typeCode = ccm.typeCode;
                this.formData.type.ccm = ccm.value;
                this.ccmTitle = ccm.title;
            }
        }

        if (this.filter.brandName && (this.filter.modelName || this.filter.typeName) && this.filter.cCm && this.filter.year) {
            await this.getYears();

            const year = this.years.find(x => x.title === this.filter.year);
            if (year) {
                this.formData.type.year = year.value;
                this.yearTitle = year.title;
            }

            if (year && this.filter.productTypes.length >= 1) {
                this.formData.type.productTypes = this.filter.productTypes;
            }

            if (this.filter.vehicleType === "Bike") {
                (<any>this.$parent).setSearchBar({ title: this.formData.type.brandName + " " + this.formData.type.modelName, subTitle: this.formData.type.ccm + " cc (" + this.years[0].title + " - " + this.years[this.years.length - 1].title + ")" });
            }
        }

        this.aftermarketList = this.searchBikeProductTypes.filter(x => x.additionalValues[0].value === 'Aftermarket').map(function (item) { return item['value']; });

        this.checkSelectionActive();
        this.setProductTypeLabel();

        if (this.filter.mode === "Code" && this.filter.code) {
            (<any>this.$parent).setSearchMode("Code");
            this.formData.code.code = this.filter.code;
        }

        this.syncFilterData();
    }

    public async getBrands() {
        this.brands = (await Axios.post(this.routes.CatalogueGlobalBikeSearch_GetSearchBrands)).data;
    }

    public async getModels() {
        this.models = (await Axios.post(this.routes.CatalogueGlobalBikeSearch_GetSearchModels, { brandName: this.formData.type.brandName })).data;
    }

    public async getCCms() {
        this.ccms = (await Axios.post(this.routes.CatalogueGlobalBikeSearch_GetSearchCCms, { brandName: this.formData.type.brandName, modelName: this.formData.type.modelName, typeName: this.formData.type.typeName })).data;
    }

    public async getYears() {
        this.years = (await Axios.post(this.routes.CatalogueGlobalBikeSearch_GetSearchYears, { typeCode: this.formData.type.typeCode })).data;
    }

    public async getCodes() {
        this.codes = (await Axios.post(this.routes.CatalogueGlobalBikeSearch_GetSearchCodeSuggestions, { codePrefix: this.formData.code.code })).data;
    }

    public async setBrandMenu() {
        if (this.brands.length === 0) {
            await this.getBrands();
        }

        this.resetSuggestionValues();
        this.suggestionMode = "Brand";

        this.formData.type.brandName = null;

        if (this.brandTitle) {
            this.suggestions = this.brands.filter(x => x.title.toLowerCase().startsWith(this.brandTitle.toLowerCase()));

            this.formData.type.brandName = this.brands.find(x => x.title.toLowerCase() === this.brandTitle.toLowerCase())?.title;
        } else {
            this.suggestions = this.brands;
        }

        if (!this.formData.type.brandName) {
            this.formData.type.modelName = null;
            this.formData.type.typeName = null;
            this.formData.type.ccm = null;
            this.formData.type.year = null;
            this.modelTitle = "";
            this.ccmTitle = "";
            this.yearTitle = "";
        }
    }

    public setBrand(brand: any) {
        if (this.suggestionIndex !== -1) {
            brand = this.suggestions[this.suggestionIndex];
        }

        if (brand) {
            this.formData.type.brandName = brand.value;
            this.brandTitle = brand.title;

            this.formData.type.modelName = null;
            this.formData.type.typeName = null;
            this.formData.type.year = null;
            this.modelTitle = "";
            this.ccmTitle = "";
            this.yearTitle = "";
            this.resetSuggestionValues();
        }
    }

    public resetBrand() {
        this.formData.type.brandName = null;
        this.formData.type.modelName = null;
        this.formData.type.typeName = null;
        this.formData.type.ccm = null;
        this.formData.type.year = null;
        this.brandTitle = "";
        this.modelTitle = "";
        this.ccmTitle = "";
        this.yearTitle = "";
    }

    public async setModelMenu() {
        await this.getModels();

        this.resetSuggestionValues();
        this.suggestionMode = "Model";

        this.formData.type.modelName = null;
        this.formData.type.typeName = null;

        if (this.modelTitle) {
            this.suggestions = this.models.filter(x => x.title.toLowerCase().startsWith(this.modelTitle.toLowerCase()));

            this.formData.type.modelName = this.models.find(x => x.title.toLowerCase() === this.modelTitle.toLowerCase())?.modelName;
            this.formData.type.typeName = this.models.find(x => x.title.toLowerCase() === this.modelTitle.toLowerCase())?.typeName;
        } else {
            this.suggestions = this.models;
        }

        if (!this.formData.type.modelName || !this.formData.type.typeName) {
            this.formData.type.ccm = null;
            this.formData.type.year = null;
            this.ccmTitle = "";
            this.yearTitle = "";
        }
    }

    public setModel(model: any) {
        if (this.suggestionIndex !== -1) {
            model = this.suggestions[this.suggestionIndex];
        }

        if (model) {
            this.formData.type.modelName = model.modelName;
            this.formData.type.typeName = model.typeName;
            this.modelTitle = model.title;

            this.formData.type.ccm = null;
            this.formData.type.year = null;
            this.ccmTitle = "";
            this.yearTitle = "";
            this.resetSuggestionValues();
        }
    }

    public resetModel() {
        this.formData.type.modelName = null;
        this.formData.type.typeName = null;
        this.formData.type.ccm = null;
        this.formData.type.year = null;
        this.modelTitle = "";
        this.ccmTitle = "";
        this.yearTitle = "";
    }

    public async setCCmMenu() {
        await this.getCCms();

        this.resetSuggestionValues();
        this.suggestionMode = "CCm";

        this.formData.type.ccm = null;

        if (this.ccmTitle) {
            this.suggestions = this.ccms.filter(x => x.title.toLowerCase().startsWith(this.ccmTitle.toLowerCase()));

            this.formData.type.ccm = this.ccms.find(x => x.title.toLowerCase() === this.ccmTitle.toLowerCase())?.value;
        } else {
            this.suggestions = this.ccms;
        }

        if (!this.formData.type.ccm) {
            this.formData.type.year = null;
            this.yearTitle = "";
        }
    }

    public setCCm(ccm: any) {
        if (this.suggestionIndex !== -1) {
            ccm = this.suggestions[this.suggestionIndex];
        }

        if (ccm) {
            this.formData.type.ccm = ccm.title;
            this.formData.type.typeCode = ccm.typeCode;
            this.ccmTitle = ccm.title;

            this.formData.type.year = null;
            this.yearTitle = "";
            this.resetSuggestionValues();
        }
    }

    public resetCCm() {
        this.formData.type.ccm = null;
        this.formData.type.year = null;
        this.ccmTitle = "";
        this.yearTitle = "";
    }

    public async setYearMenu() {
        await this.getYears();

        this.resetSuggestionValues();
        this.suggestionMode = "Year";

        this.formData.type.year = null;

        if (this.yearTitle) {
            this.suggestions = this.years.filter(x => x.title.toLowerCase().startsWith(this.yearTitle.toLowerCase()));

            this.formData.type.year = this.years.find(x => x.title.toLowerCase() === this.yearTitle.toLowerCase())?.value;
        } else {
            this.suggestions = this.years;
        }
    }

    public setYear(year: any) {
        if (this.suggestionIndex !== -1) {
            year = this.suggestions[this.suggestionIndex];
        }

        if (year) {
            this.formData.type.year = year.value;
            this.yearTitle = year.title;
            this.resetSuggestionValues();
        }
    }

    public resetYear() {
        this.formData.type.year = null;
        this.yearTitle = "";
    }

    public setProductTypeMenu() {
        this.isProductTypeMenu = !this.isProductTypeMenu;
    }

    public async setCodeMenu() {
        if (this.formData.code.code?.length >= 3) {
            await this.getCodes();
        }

        this.resetSuggestionValues();
        this.suggestionMode = "Code";

        if (this.formData.code.code?.length >= 3) {
            this.suggestions = this.codes;
        }

        (this.formData.code.code?.length >= 3 && this.suggestions.length === 0) ? this.isReportCode = true : this.isReportCode = false;
        this.isReported = false;
    }

    public setCode(code: any) {
        if (this.suggestionIndex !== -1) {
            code = this.suggestions[this.suggestionIndex];
        }

        if (code) {
            GTagHelper.sendCustomEvent("view_search_results", { search_type: "code", veichle_type: "bike", product_code: this.formData.code.code });
            window.location.href = code.url;
            this.isLoading = true;
        } else if (this.formData.code.code) {
            this.submitCodeForm();
        }
    }

    public reportCode() {
        GTagHelper.sendCustomEvent("click", { reportcode_bike: this.formData.code.code });

        this.isReported = true;
    }

    public setProductTypes(e: any) {
        this.formData.type.productTypes = this.vehicleFilter.productTypes;

        if (e.target.value === "All") {
            this.formData.type.productTypes = this.formData.type.productTypes.length === 0 ? ["Pad"] : ["All"];
        } else if (e.target.value === "AddAftermarket") {
            this.formData.type.productTypes = this.formData.type.productTypes.concat(this.aftermarketList);
            this.formData.type.productTypes = [...new Set(this.formData.type.productTypes)];
        } else if (e.target.value === "LessAftermarket") {
            this.formData.type.productTypes = this.formData.type.productTypes.filter(x => !this.aftermarketList.includes(x));
        }

        this.formData.type.productTypes = this.formData.type.productTypes.length === 0 ? ["All"] : this.formData.type.productTypes.filter(x => x !== "All");

        this.checkSelectionActive();

        this.setProductTypeLabel();

        this.syncFilterData();
    }

    public checkSelectionActive() {
        this.isSelectingAllAftermarket = this.aftermarketList.every(item => this.formData.type.productTypes.includes(item)) ? false : true;
    }

    public setProductTypeLabel() {
        if (!this.formData.type.productTypes.includes("All")) {
            this.selectedProductTypes = (this.searchBikeProductTypes.filter(x => this.formData.type.productTypes.includes(x.value)).map(x => x.title).slice(0, 2)).join(", ");

            if (this.formData.type.productTypes.length === this.searchBikeProductTypes.length) {
                this.selectedProductTypes = null;
            } else if (this.formData.type.productTypes.length > 2) {
                this.selectedProductTypes += " +" + (this.formData.type.productTypes.length - 2);
            }
        } else {
            this.selectedProductTypes = null;
        }
    }

    public syncFilterData() {
        let data = {
            vehicleType: "Bike",
            productTypes: this.formData.type.productTypes,
            isSelectingAllAftermarket: this.isSelectingAllAftermarket,
            selectedProductTypes: this.selectedProductTypes
        }

        this.$emit("setFilterData", data);
    }

    public resetSuggestionValues() {
        this.suggestionIndex = -1;
        this.suggestions = [];
    }

    public async submitTypeForm() {
        this.validationErrors = [];

        try {
            const result = (await Axios.post(this.routes.CatalogueGlobalBikeSearch_SearchType, this.formData.type)).data;

            GTagHelper.sendCustomEvent("view_search_results", { search_type: "type", veichle_type: "bike", product_application: this.formData.type.modelName + " " + this.formData.type.typeName + " " + this.formData.type.ccm });

            window.location.href = result.url;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
    }

    public async submitCodeForm() {
        this.validationErrors = [];

        try {
            const result = (await Axios.post(this.routes.CatalogueGlobalBikeSearch_SearchCode, this.formData.code)).data;
            GTagHelper.sendCustomEvent("view_search_results", { search_type: "code", veichle_type: "bike", product_code: this.formData.code.code });
            window.location.href = result.url;
            this.isLoading = true;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
    }

    public suggestionMoveDown() {
        if (this.suggestions.length !== 0 && this.suggestionIndex < this.suggestions.length - 1) {
            this.suggestionIndex++;

            this.$nextTick(function () {
                this.checkIsInViewport();
            });
        }
    }

    public suggestionMoveUp() {
        if (this.suggestions.length !== 0 && this.suggestionIndex > 0) {
            this.suggestionIndex--;

            this.$nextTick(function () {
                this.checkIsInViewport();
            });
        }
    }

    public checkIsInViewport() {
        let myElement = document.querySelector(".search-result[data-selected='true']");
        let box = document.querySelector(".wrapper-result");

        const isInViewport = box.getBoundingClientRect().top >= 0 &&
            box.getBoundingClientRect().left >= 0 &&
            box.getBoundingClientRect().bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            box.getBoundingClientRect().right <= (window.innerWidth || document.documentElement.clientWidth);

        if (!myElement) { return; }

        if (!isInViewport) {
            (<any>myElement).scrollIntoView({ behavior: "smooth", block: "center" });
            return;
        }

        const isVisible = function (myElement, box) {
            const { bottom, height, top } = myElement.getBoundingClientRect();
            const containerRect = box.getBoundingClientRect();

            return top <= containerRect.top ? containerRect.top - top <= height : bottom - containerRect.bottom <= height;
        };

        if (!isVisible(myElement, box)) {
            (<any>myElement).scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};